import '../styles/student-theme.css'
const key = 'nim-student-theme'
export default {
  data: () => ({ studentTheme: 'light' }),
  mounted() {
    this._themeMedia = window.matchMedia('(prefers-color-scheme: dark)')
    let saved = null
    try { saved = window.localStorage.getItem(key) } catch (_) { /* Storage can be unavailable. */ }
    this._themeManual = saved === 'light' || saved === 'dark'
    this.studentTheme = this._themeManual ? saved : (this._themeMedia.matches ? 'dark' : 'light')
    this._themeListener = event => { if (!this._themeManual) this.studentTheme = event.matches ? 'dark' : 'light' }
    if (this._themeMedia.addEventListener) this._themeMedia.addEventListener('change', this._themeListener)
    else this._themeMedia.addListener(this._themeListener)
  },
  beforeDestroy() {
    if (!this._themeMedia) return
    if (this._themeMedia.removeEventListener) this._themeMedia.removeEventListener('change', this._themeListener)
    else this._themeMedia.removeListener(this._themeListener)
  },
  methods: {
    toggleStudentTheme() {
      this.studentTheme = this.studentTheme === 'dark' ? 'light' : 'dark'
      this._themeManual = true
      try { window.localStorage.setItem(key, this.studentTheme) } catch (_) { /* Keep this session's selection. */ }
    }
  }
}
